<template>
    <div class="box">
      <nav-bar></nav-bar>
      <home-content ref="home_content"></home-content>
      <software-home ref="software_home"></software-home>
      <resource-rank ref="resource_rank"></resource-rank>
      <bottom-slider></bottom-slider>
    </div>
</template>

<script>
import HomeContent from '@/components/sysHome/HomeContent.vue'
import SoftwareHome from '@/components/sysHome/SoftwareHome.vue';
import ResourceRank from '@/components/sysHome/ResourceRank.vue';
export default {
        name: "SysHome",
        components:{HomeContent,SoftwareHome,ResourceRank},
        data(){
            return{
              
            }
        },
        methods:{
            lazyPage(id,callback){
                var dom=document.querySelector(id);
                // 创建一个IntersectionObserver实例
                const lazyLoad = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                    typeof callback=='function'&&callback();
                    dom&&observer.unobserve(dom); // 停止观察该图像
                    }
                });
                },{
                    threshold: 0 // 触发阈值
                });
                dom&&lazyLoad.observe(dom);
            },
            /**渐进式页面显现 */
            visiablePage(className){
                let dom=document.querySelector(`.${className}`);
                if(!dom)return;
                dom.style.setProperty('opacity', '1', 'important');
                dom.style.setProperty('transform','translateY(0)','important');
            }
        },
        mounted(){
            let ref1=this.$refs.home_content;
            let ref2=this.$refs.software_home;
            let ref3=this.$refs.resource_rank;
            this.lazyPage('.show-resource-box',()=>{
                this.visiablePage('show-resource-box');
                ref1&&ref1.getResDataCount();
            })
            this.lazyPage('.show-video-box',()=>{
                this.visiablePage('show-video-box');
                ref1&&ref1.getResData();
            })
            this.lazyPage('.software-show-box',()=>{
                this.visiablePage('software-show-box');
                if(ref2){
                    ref2.getHomeSoftware();
                    ref2.getOptCount();
                }
            })
            this.lazyPage('.rank-observe',()=>{
                this.visiablePage('rank-observe');
                if(ref3){
                    ref3.getDataRanking(0);
                    ref3.getDataRanking(1);
                    ref3.getDataRanking(2);
                }
            })
            this.lazyPage('.college-observe',()=>{
                // this.visiablePage('college-observe');
                if(ref3){
                    ref3.pageHomeSchoolList();
                }
            })
        }
    }
</script>
<style scoped lang="less">
</style>
